'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, RefObject } from 'react';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import css from '../style.module.scss';
import { CasesScrollItemDto, CasesSliderResolvedLayout } from '../types';
interface Props {
  cases: CasesScrollItemDto[];
  activeIndex: number;
  tabItemsRef: RefObject<(HTMLLIElement | null)[]>;
  layout: CasesSliderResolvedLayout;
}
const CasesSliderTabs: FC<Props> = t0 => {
  const $ = _c(15);
  const {
    cases,
    activeIndex,
    tabItemsRef,
    layout
  } = t0;
  const t1 = layout.index && css.leftWithIndex;
  let t2;
  if ($[0] !== t1) {
    t2 = clsx(css.left, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== activeIndex || $[3] !== layout.index) {
    t3 = layout.index ? <Typography className={css.index} variant="body-l" tag="span">{String(activeIndex + 1).padStart(2, "0")}</Typography> : null;
    $[2] = activeIndex;
    $[3] = layout.index;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeIndex || $[6] !== cases || $[7] !== layout.leftSideText || $[8] !== layout.leftSideTitle || $[9] !== tabItemsRef) {
    t4 = layout.leftSideTitle ? <ul className={css.tabs} aria-label="Cases tabs">{cases.map((slide, i) => {
        const isActive = i === activeIndex;
        return <li key={`${slide.tabLabel}-${i}`} ref={el => {
          tabItemsRef.current[i] = el;
        }} className={clsx(css.tab, isActive && css.activeTab)} role="button" tabIndex={0} aria-pressed={isActive}><Typography className={css.tabLabel} variant={isActive ? "h5" : "h6"} tag="h2">{slide.tabLabel}</Typography>{layout.leftSideText ? <div className={css.tabDescriptionWrap}><Typography className={css.tabDescription} variant="body-m" tag="div">{typeof slide.tabDescription === "string" ? slide.tabDescription : slide.tabDescription ? <StrapiRichContent content={slide.tabDescription} /> : null}</Typography></div> : null}</li>;
      })}</ul> : null;
    $[5] = activeIndex;
    $[6] = cases;
    $[7] = layout.leftSideText;
    $[8] = layout.leftSideTitle;
    $[9] = tabItemsRef;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <aside className={t2}>{t3}{t4}</aside>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default CasesSliderTabs;